import { PosologyBottomPanel } from './PosologyBottomPanel.component'
import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'

const withUnmountHoc = withUnmountTransition(PosologyBottomPanel)
export { withUnmountHoc as PosologyBottomPanel }
